import TranslationText from '@Components/Utilities/TranslationText';

const BlogArticleArchiveMenu = (props) => {
    return (
        <div className='blog-list-right-menu'>
            <div className='blog-list-right-menu-header'>
                <i className='fas fa-rss' aria-hidden='true' /> &nbsp; <TranslationText tKey='sandhills.blogarchive' />
            </div>
            {props.ArchiveArticleList && props.ArchiveArticleList.length > 0 && props.ArchiveArticleList.map((article, index) =>
                <div key={index} className='blog-home-post'>
                    <div className='blog-home-post-title'>
                        <a href={article.Url}><strong>{article.PageHeader}</strong></a>
                    </div>
                    <strong><TranslationText tKey='sandhills.dealerservices.boards.mvc.posted' /> {article.DisplayLastUpdate ? article.UpdatedDateFormatted : article.PostedDateFormatted}</strong>
                    <br />
                    <div className='blog-home-post-body'>
                        {article.SummaryPlainText}
                    </div>
                    <a href={article.Url}><strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.readthefullblogpost' /></strong></a>
                </div>)}
        </div>
    );
};

export default BlogArticleArchiveMenu;